module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kg-Lc.491a51a6.png";